import React, { useState } from 'react';
import './PoweredBy.css';
import PartnerModal from '../Partners/PartnerModal';

const PoweredBy = ({ onApplyNow }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section className="pb-root">
      <p className="pb-label">Powered By</p>
      <div
        className="pb-card"
        onClick={() => setModalOpen(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && setModalOpen(true)}
        aria-label="Learn more about IIT Mandi"
      >
        <img src="/heroes/iitmandi.webp" alt="IIT Mandi" className="pb-image" />
        <div className="pb-logo-badge">
          <img src="/logos/iitlogo.png" alt="IIT Mandi Logo" className="pb-logo-img" />
        </div>
        <div className="pb-overlay">
          <p className="pb-overlay-text">Explore BCA and B.Tech in AI with IIT, Mandi</p>
          <span className="pb-overlay-cta">
            View Details
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </span>
        </div>
      </div>

      {modalOpen && (
        <PartnerModal
          partnerKey="iitmandi"
          onClose={() => setModalOpen(false)}
          onApplyNow={onApplyNow}
        />
      )}
    </section>
  );
};

export default PoweredBy;
